
window.OnCISInfoReady = function () {

    $(".col-info-icon").on("click", function () {
        var action = $(this).data("action");

        if (action == "logout") {
            document.location.href = "/Brand/" + $("#brandCode").val() + "/Account/Logout";
        }
        else if (action == "language") {
            LanguagesMenu(true);
        }
        else if (action == "cs") {
            CSMenu(true);
        }
    });

    $("#languageMenu").on("click", "a", function () {
        ChangeLanguage($(this).data("code"));
    });

    $('a[href^="#"]').on('click', function (event) {

        var target = $(this.getAttribute('href'));

        if (target.length) {
            event.preventDefault();
            $('.body-content').stop().animate({
                scrollTop: target.offset().top + 200
            }, 1000);
        }
    });
}

window.LanguagesMenu = function (show) {
    $(".language-overlay").css("left", show ? "0px" : "-20px");
    $(".language-overlay").css("width", show ? "100%" : "0px");
}

window.CSMenu = function (show) {
    $(".cs-overlay").css("left", show ? "0px" : "-20px");
    $(".cs-overlay").css("width", show ? "100%" : "0px");
}